/**
 * <tile-strip> — dots under the tile grid while it is a swipe strip on phones.
 *
 * The strip is plain scroll-snap, so it swipes without this file. This marks
 * the dot of whichever tile sits nearest the middle of the strip (the tiles
 * snap to centre and are narrower than the screen, so the scroll position
 * divided by the width would drift), and scrolls to a tile when its dot is
 * tapped. On wider screens the dots are hidden and nothing here runs visibly.
 */
(function () {
  'use strict';

  class TileStrip extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;

      this.track = this.querySelector('[data-strip-track]');
      this.dots = Array.from(this.querySelectorAll('[data-strip-dot]'));
      if (!this.track || this.dots.length < 2) return;
      this.tiles = Array.from(this.track.children);
      this.index = 0;

      this.addEventListener('click', (event) => {
        const dot = event.target.closest('[data-strip-dot]');
        if (dot) this.go(Number(dot.dataset.stripDot));
      });

      this.track.addEventListener('scroll', () => this.queueSync(), { passive: true });
    }

    go(index) {
      const tile = this.tiles[index];
      if (!tile) return;
      // `scrollLeft` rather than a smooth `scrollTo`: mandatory snapping
      // cancels a scripted smooth scroll.
      this.track.scrollLeft =
        tile.offsetLeft - this.tiles[0].offsetLeft - (this.track.clientWidth - tile.offsetWidth) / 2;
      this.set(index);
    }

    queueSync() {
      if (this.queued) return;
      this.queued = true;
      window.requestAnimationFrame(() => {
        this.queued = false;
        const middle = this.track.getBoundingClientRect().left + this.track.clientWidth / 2;
        let nearest = 0;
        let best = Infinity;
        this.tiles.forEach((tile, i) => {
          const box = tile.getBoundingClientRect();
          const distance = Math.abs(box.left + box.width / 2 - middle);
          if (distance < best) {
            best = distance;
            nearest = i;
          }
        });
        this.set(nearest);
      });
    }

    set(index) {
      if (index === this.index) return;
      this.index = index;
      this.dots.forEach((dot, i) => {
        dot.setAttribute('aria-current', i === index ? 'true' : 'false');
      });
    }
  }

  if (!customElements.get('tile-strip')) {
    customElements.define('tile-strip', TileStrip);
  }
})();
